import { render } from "./Langauge.vue?vue&type=template&id=1d0554eb&scoped=true&ts=true"
import script from "./Langauge.vue?vue&type=script&lang=ts"
export * from "./Langauge.vue?vue&type=script&lang=ts"

import "./Langauge.vue?vue&type=style&index=0&id=1d0554eb&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0554eb"]])

export default __exports__